<div class="ft">
  <button
    type="button"
    class="ft__btn ft__btn--root"
    [class.ft__btn--active]="isSelected('')"
    (click)="pick('')"
  >
    {{ root().label }}
  </button>

  <ng-template #branch let-node>
    <ul class="ft__list">
      @for (c of node.children; track c.path) {
        <li class="ft__item">
          <button
            type="button"
            class="ft__btn"
            [class.ft__btn--active]="isSelected(c.path)"
            (click)="pick(c.path)"
          >
            {{ c.label }}
          </button>
          @if (c.children.length > 0) {
            <ng-container *ngTemplateOutlet="branch; context: { $implicit: c }" />
          }
        </li>
      }
    </ul>
  </ng-template>

  @if (root().children.length > 0) {
    <ng-container *ngTemplateOutlet="branch; context: { $implicit: root() }" />
  }
</div>
